/* eslint-disable no-underscore-dangle */
export const NETWORK_CHAIN_IDS = {
  mainnet: 1,
  ropsten: 3,
  rinkeby: 4,
  goerli: 5,
  kovan: 42,
  bsc: 56,
};

// export const INFURA_ENDPOINT = 'https://mainnet.infura.io/v3/49a547b1f17a417f8b7fe8dc8d33308e';
export const INFURA_ENDPOINT = 'url: "https://bsc-dataseed4.binance.org/",';